import { Lang, ValidationErrorCode } from 'cat-shared/utils'

export default {
  [Lang.EN]: {
    [ValidationErrorCode.AlreadyTaken]: 'is already taken',
    [ValidationErrorCode.IncorrectPassword]: 'incorrect password',
    [ValidationErrorCode.NoSuchEmail]: 'no such email',
  },
}
